import React from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import classNames from 'classnames';

import {REIMBURSEMENT_TYPE} from '../../../constants/usersConstrains';
import {Logo} from '../components/Logo';
import logo from '../../../images/Logo.png';
import sign from '../../../images/rayan.png';
import HeaderSearch from '../components/HeaderSearch'

@withRouter
@inject('sideBarStore')
@inject('userStore')
@inject('headerStore')
@observer
export default class extends React.Component {
  static defaultProps = {};

  handleSidebar = () => {
    this.props.sideBarStore.activate();
  };

  handleIsLanding = (location) => {
    return location.pathname === '/' || location.pathname === '/pricing';
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if(this.props.location.pathname === '/' || this.props.location.pathname === '/pricing') {
      const el = document.getElementsByClassName('landing');
      const elPos = el[0].getBoundingClientRect();
      const wasScrolled = this.props.headerStore.isScrolled;

      if((elPos.top < -5) && !wasScrolled) {
        this.props.headerStore.scrolled();
      }

      if((elPos.top > -5) && wasScrolled) {
        this.props.headerStore.scrolled();
      }
    }
  };

  isReimbursedType = () => {
    const {userStore} = this.props;
    const userType = userStore.user ? userStore.user.user_type : -1;
    return REIMBURSEMENT_TYPE.includes(userType);
  }

  render() {
    const {location, userStore} = this.props;
    const activeSearch = this.props.headerStore.isActiveSearch;
    const wasScrolled = this.props.headerStore.isScrolled;
    const isReimbursed = this.isReimbursedType() && userStore.user.country === 'Ireland';
    const isLanding = this.handleIsLanding(location) && !userStore.user;

    return (
      <header className={classNames('main-header fixed-top', {
        'landing-header': isLanding,
        'is-scrolling': wasScrolled
      })}>
        <div className="container-fluid">
          <div className="row align-items-center justify-content-between">
            <div className={`col-5 col-sm-4 col-md-${isLanding ? '5' : '2'}`}>
              <div className='row justify-content-start'>
                <NavLink
                  className={classNames('logo', {'searchActive': activeSearch})}
                  style={{paddingLeft: '15px'}}
                  to={userStore.user ? '/' : '/'}>
                  {Logo}
                  <img src={logo} style={{ visibility: 'hidden', width: 0, height: 0 }} />
                  <img src={sign} style={{ visibility: 'hidden', width: 0, height: 0 }} />
                </NavLink>
                {isLanding && (
                  <div className="column" style={{marginLeft: '15px'}}>
                    <a className='header-link' href="tel:0879418027">085 724 6527</a>
                    <a className='header-link' href="mailto:support@prescriptionrevision.ie">support@prescriptionrevision.ie</a>
                  </div>
                )}
              </div>
            </div>
            {isLanding && (
                <span style={{color: 'rgba(255, 255, 255, 0.7)'}} className='header-link'>
                  Already have an account? <NavLink to='/signIn' className='header-link'>LOG IN</NavLink>
                </span>
            )}
            {userStore.isAdmin() ?
              <NavLink className="col-5 col-md-1" to="/topic/">
                <div className="btn blue rounded" style={{minWidth: 'auto', top: `${-5}px`, padding: `${10}px ${20}px`}}>
                  <span>add new topic</span>
                </div>
              </NavLink> :
              userStore.user && userStore.user.user_type !== 4 ? (
                <NavLink className={`col-5 col-md-${isReimbursed ? '2' : '3'}`} to="/topic/73">
                  <div className="btn blue rounded" style={{minWidth: 'auto', top: `${-5}px`, padding: `${10}px ${20}px`}}>
                    <span>MICGP EXAM PREP</span>
                  </div>
                </NavLink>
              ) : null
            }
            {userStore.isAdmin() && ([
              <NavLink className={`col-5 col-md-1`} to="/practice-cases/add">
                <div className="btn blue rounded" style={{minWidth: 'auto', top: `${-5}px`, padding: `${10}px ${20}px`}}>
                  <span>Add New Resource</span>
                </div>
              </NavLink>,
              <NavLink className={`col-5 col-md-1`} to={`/practice-cases`}>
                <div className="btn blue rounded" style={{minWidth: 'auto', top: `${-5}px`, padding: `${10}px ${20}px`}}>
                  <span>Resources</span>
                </div>
              </NavLink>,
            ])}
            {userStore.user && (
              <NavLink className="col-5 col-md-1" to="/dashboard">
                <div className="btn blue rounded" style={{minWidth: 'auto', top: `${-5}px`, padding: `${10}px ${20}px`}}>
                  <span>CLINICAL TOPICS</span>
                </div>
              </NavLink>
            )}
            {isReimbursed ? (
              <NavLink className="col-5 col-md-1" to="/reimbursed">
                <div className="btn blue rounded" style={{minWidth: 'auto', top: `${-5}px`, padding: `${10}px ${20}px`}}>
                  <span>REIMBURSEMENT</span>
                </div>
              </NavLink>
             ) : null
            }
            <div className="col-2 col-md-2">
              <div className="header-left-holder">
                <HeaderSearch/>
                <i onClick={this.handleSidebar}
                   className="ic ic-burger menu"/>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
  }
}




// WEBPACK FOOTER //
// ./src/modules/core/containers/Header.js